import { createSlice } from '@reduxjs/toolkit';
import { DeviceEvent } from 'src/models';
import {
  getDeviceEventsAction,
  GetDeviceEventsQueryParams,
  sortDeviceEvents,
} from 'src/services/deviceEvents';
import { CalendarDate } from 'src/components/general';

const initQueryParams: GetDeviceEventsQueryParams = {
  start: new CalendarDate().setFirstDay().format,
  end: new CalendarDate().setLastDay().format,
  eventType: 'ev_controller_connected',
};

const initialState: {
  events: DeviceEvent[];
  queryParams: GetDeviceEventsQueryParams;
  isPending: boolean;
  hasError: boolean;
} = {
  events: [],
  queryParams: initQueryParams,
  isPending: false,
  hasError: false,
};

const deviceEventsSlice = createSlice({
  name: 'device_events',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDeviceEventsAction.pending, (state) => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(
      getDeviceEventsAction.fulfilled,
      (state, { payload, meta }) => {
        state.isPending = false;
        const newQuery =
          state.queryParams.eventType !== meta.arg.params.eventType ||
          state.queryParams.humanId !== meta.arg.params.humanId ||
          state.queryParams.phyDeviceId !== meta.arg.params.phyDeviceId;
        state.queryParams = meta.arg.params;
        state.events = sortDeviceEvents(
          newQuery ? payload : [...state.events, ...payload],
        );
      },
    );
    builder.addCase(getDeviceEventsAction.rejected, (state) => {
      state.isPending = false;
      state.hasError = true;
    });
  },
});

export default deviceEventsSlice.reducer;
